export default class Modo
{
    static encontreSeuDentista = "ENCONTRE SEU DENTISTA";
    static redeSubstituicao = "REDE SUBSTITUIÇÃO"; 
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/enums/modo.ts
 **/